export default __webpack_public_path__ + "static/media/mail.6e459ec7.svg";